/* eslint-disable react/jsx-key */
import React, { FC } from 'react'
import {
  Car,
  Wifi,
  Cafeteria,
  Toast,
  TreeOption,
  Lounge,
  Group,
  Phone,
  Restaurant,
  Bar,
  Train,
  CoatCheck,
  Ticket,
  Attraction,
  User,
  AidOption,
  Atm,
  Spa,
  Swim,
  Wheelchair,
} from 'grommet-icons'

interface IconsPropsI {
  name: string
}

const iconsMapping = new Map([
  ['car', <Car color="status-ok" />],
  ['wifi', <Wifi color="status-ok" />],
  ['cafeteria', <Cafeteria color="status-ok" />],
  ['toast', <Toast color="status-ok" />],
  ['lounge', <Lounge color="status-ok" />],
  ['treeOption', <TreeOption color="status-ok" />],
  ['group', <Group color="status-ok" />],
  ['phone', <Phone color="status-ok" />],
  ['restaurant', <Restaurant color="status-ok" />],
  ['bar', <Bar color="status-ok" />],
  ['train', <Train color="status-ok" />],
  ['coatCheck', <CoatCheck color="status-ok" />],
  ['ticket', <Ticket color="status-ok" />],
  ['attraction', <Attraction color="status-ok" />],
  ['user', <User color="status-ok" />],
  ['aidOption', <AidOption color="status-ok" />],
  ['atm', <Atm color="status-ok" />],
  ['spa', <Spa color="status-ok" />],
  ['swim', <Swim color="status-ok" />],
  ['wheelChair', <Wheelchair color="status-ok" />],
  ['wifi-lg', <Wifi color="brand" size="large" />],
  ['lounge-lg', <Lounge color="brand" size="large" />],
  ['cafeteria-lg', <Cafeteria color="brand" size="large" />],
  ['toast-lg', <Toast color="brand" size="large" />],
  ['group-lg', <Group color="brand" size="large" />],
])

const Icons: FC<IconsPropsI> = ({ name }: IconsPropsI) => (
  <React.Fragment>{iconsMapping.has(name) ? iconsMapping.get(name) : <span>Icon not found</span>}</React.Fragment>
)

export default Icons
